import React from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {t, withState} from 'shared/core';
import {Display, Layout, Panel, FormLayout, Input, TextArea, Button} from 'shared/components';
import {EditExpenseState} from '../state';
import ExpenseList from './ExpenseList';

const EditExpenseContainer = observer(({uiState}) => {
  const {request, errors, total, isEditing, backPath, backTitle} = uiState;

  return (
    <div>
      <Display
        title={isEditing ? t('expenses.edit.Edit expense request') : t('expenses.edit.New expense request')}
        backPath={backPath}
        backTitle={backTitle}
      />
      <Layout>
        <Panel.Stack loose>
          <Panel>
            <Panel.Header
              title={t('expenses.edit.Request details')}
              description={t('expenses.edit.Provide a title and brief description for this expense request.')}
            />
            <FormLayout>
              <Input
                label='expenses.edit.Title'
                value={request.title}
                onChange={e => request.title = e.target.value}
                errorMessage={errors.title}
              />
              <TextArea
                label='expenses.edit.Description'
                value={request.description}
                minRows={3}
                onChange={e => request.description = e.target.value}
                errorMessage={errors.description}
              />
            </FormLayout>
          </Panel>
          <Panel>
            <Panel.Header
              title={t('expenses.edit.Expenses')}
              description={t('expenses.edit.Add each individual expense with a category and receipt.')}
            />
            <ExpenseList uiState={uiState}/>
            <Panel.Separator/>
            <div className='flex justify-content-between align-items-center mt2'>
              <div className='h2 medium'>
                <FormattedMessage id='expenses.edit.TOTAL' values={{total}}/>
              </div>
              <Button onClick={() => uiState.submit()}>
                <FormattedMessage id={isEditing ? 'expenses.edit.Save' : 'expenses.edit.Submit request'}/>
              </Button>
            </div>
          </Panel>
        </Panel.Stack>
      </Layout>
    </div>
  );
});

export default withState(EditExpenseContainer, EditExpenseState);
